module.exports = __webpack_public_path__ + "static/img/bg.72024d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.jpg
// module id = dZ/S
// module chunks = 1